export default __webpack_public_path__ + "7fd7e27.png";